export class InActive {
    static N = 'N';
    static Y = 'Y';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}

export class Normal_Yes_No_Class {
    static N = 'N';
    static Y = 'Y';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}


export class Report_Package_Type_Model {
    // static N = 'N';
    // static Y = 'Y';
    static PACKAGE = '1';
    static PREPAY = '2';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}


export class Report_SalesMonth_Type_Model {
    // static N = 'N';
    // static Y = 'Y';
    static ITEM = '1';
    static PACKAGE = '2';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}

export class JournalTypeClass {
    static PV = 'PV';
    static JV = 'JV';

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}


export class LoginUserActive {
    static N = true;
    static Y = false;

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}


export class PaymentMethodStatusModel {
    static ALL = "All";
    static ACTIVE = "Active";
    static INACTIVE = "Inactive";
    static NOTHING = "Nothing";

    value: string;
    displayName: string;
    constructor(value, displayName) {
        this.value = value;
        this.displayName = displayName;
    }
}